import { render, staticRenderFns } from "./SummaryTransactionsItem.vue?vue&type=template&id=01e8a45f&scoped=true&"
import script from "./SummaryTransactionsItem.vue?vue&type=script&lang=js&"
export * from "./SummaryTransactionsItem.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTransactionsItem.vue?vue&type=style&index=0&id=01e8a45f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e8a45f",
  null
  
)

export default component.exports